var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCanvas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 28,
    viewBox: "0 0 73 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1815_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6253 13.9114C55.0655 13.9322 54.5342 14.1703 54.1384 14.5776C53.7427 14.985 53.512 15.5313 53.4928 16.1065V17.7822C53.4928 17.8115 53.4928 17.8366 53.4928 17.8618C53.479 18.4438 53.2453 18.9975 52.8412 19.4056C52.4371 19.8138 51.8942 20.0444 51.3276 20.0486H51.14C50.8525 20.0464 50.5682 19.986 50.3033 19.871C50.0385 19.7559 49.7983 19.5883 49.5965 19.3778C49.3947 19.1674 49.2352 18.9181 49.1271 18.6444C49.0191 18.3706 48.9646 18.0776 48.9667 17.7822V12.0262H51.7027V11.6533C51.6027 11.2349 51.3795 10.8582 51.0636 10.5748C50.7476 10.2915 50.3542 10.1151 49.9372 10.0698H48.9667V8.33545H46.9279C46.9279 8.38991 46.9279 8.42761 46.9279 8.48626V17.7864C46.9226 18.3451 47.0246 18.8994 47.2283 19.4175C47.4319 19.9355 47.7331 20.4072 48.1146 20.8053C48.4961 21.2035 48.9504 21.5204 49.4514 21.7378C49.9524 21.9551 50.4902 22.0687 51.034 22.072H51.5192C52.0908 22.0709 52.6557 21.9453 53.1765 21.7033C53.6974 21.4614 54.1623 21.1087 54.5407 20.6686C55.2382 19.8813 55.625 18.8551 55.6253 17.7905V13.9114Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0772 12.1138H43.0303V21.8747H45.0772V12.1138Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0303 10.2037H43.3443C43.7474 10.2463 44.1286 10.4131 44.4379 10.6822C44.7471 10.9514 44.97 11.3103 45.0772 11.7118V8.43164H43.0384L43.0303 10.2037Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5184 20.1365C56.3325 20.131 56.1473 20.1128 55.9638 20.082C55.6437 20.7243 55.2014 21.2941 54.6631 21.7577C55.179 21.924 55.7133 22.0226 56.2533 22.051C56.3022 22.051 56.343 22.051 56.392 22.051H59.5357V20.1029H56.5999C56.5714 20.1239 56.5469 20.1365 56.5184 20.1365Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.519 11.1C55.1136 11.0967 53.75 11.5908 52.6576 12.4991C52.5475 12.5913 52.4292 12.6751 52.3273 12.7757C51.8157 13.2624 51.407 13.852 51.1264 14.5078C50.8459 15.1635 50.6994 15.8715 50.6963 16.5879C50.697 17.6417 51.0224 18.6682 51.626 19.5203C51.8593 19.4744 52.0782 19.3706 52.2637 19.218C52.4492 19.0655 52.5956 18.8687 52.6902 18.6448C52.6902 18.6448 52.8003 18.5107 52.7921 18.0206C52.7921 17.7818 52.7921 17.4299 52.7921 17.1325C52.7972 16.7083 52.8519 16.2864 52.9553 15.8757C53.0372 15.4681 53.1905 15.0791 53.4079 14.7279C53.7315 14.2335 54.1665 13.8268 54.676 13.5423C55.2549 13.2078 55.9078 13.0317 56.572 13.0312H56.5965C57.4984 13.0057 58.3766 13.3299 59.0565 13.9391C59.7364 14.5484 60.1683 15.3983 60.2663 16.3198V22.0548H62.358V16.3365C62.2848 15.1008 61.7862 13.9322 60.9513 13.0396C60.3831 12.4191 59.6959 11.9264 58.933 11.5925C58.1701 11.2587 57.3482 11.0909 56.519 11.1Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6412 11.146H68.2334C67.6885 11.1471 67.1491 11.2586 66.6462 11.4739C66.1432 11.6893 65.6865 12.0044 65.3021 12.4013C64.9177 12.7981 64.6133 13.2689 64.4061 13.7867C64.1989 14.3045 64.0931 14.8592 64.0947 15.4191V19.8931C64.0947 20.0062 64.0947 20.111 64.1192 20.2199C64.1438 20.7028 64.3415 21.1593 64.6743 21.5012C65.0072 21.8432 65.4514 22.0463 65.9215 22.0716H66.1539V15.3185C66.1528 14.7259 66.3806 14.1571 66.7873 13.7369C67.194 13.3167 67.7464 13.0795 68.3231 13.0772H68.5026C69.0793 13.0795 69.6317 13.3167 70.0384 13.7369C70.4451 14.1571 70.6729 14.7259 70.6718 15.3185V20.1403C70.6718 20.1403 70.6718 20.1403 70.6718 20.1738V20.2283C70.6729 20.712 70.8606 21.1755 71.1939 21.5171C71.5272 21.8588 71.9788 22.0506 72.4496 22.0506H72.7921V16.3909V15.4065C72.7921 14.8466 72.6847 14.2923 72.4761 13.7751C72.2674 13.2579 71.9616 12.7881 71.5761 12.3924C71.1906 11.9967 70.7329 11.683 70.2294 11.4691C69.7258 11.2553 69.1861 11.1454 68.6412 11.146Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5375 8.42314H31.2051C31.2051 8.42314 31.2051 8.46504 31.2051 8.48179C31.2051 8.95177 31.3868 9.40251 31.7103 9.73483C32.0337 10.0672 32.4724 10.2538 32.9299 10.2538H35.3519V19.8891C35.4294 20.9951 35.8657 21.8706 36.9829 21.8706H37.46V10.2329H39.9065C40.3461 10.2063 40.7594 10.0087 41.0623 9.68037C41.3653 9.35201 41.5352 8.9175 41.5375 8.46507V8.41895V8.42314Z",
    fill: "#C6A678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2221 15.0841H17.7368C14.5316 15.0692 11.3677 15.8266 8.49902 17.2955C5.63035 18.7644 3.13687 20.9039 1.21875 23.5422L9.54098 8.91333L14.0589 0.953771C14.169 0.762098 14.3203 0.598883 14.5013 0.476601C14.6823 0.354318 14.8881 0.276223 15.1031 0.24832C15.318 0.220416 15.5363 0.243439 15.7412 0.315617C15.9461 0.387796 16.1322 0.507177 16.2852 0.664687C17.8879 3.71688 18.7193 7.13361 18.7032 10.6016C18.7001 12.1092 18.5388 13.612 18.2221 15.0841Z",
    fill: "url(#paint0_linear_1815_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0525 27.6057C24.008 27.3968 19.2163 25.2813 15.5967 21.6654C16.8327 19.65 17.7211 17.4307 18.2226 15.1051C18.5385 13.6371 18.6998 12.1385 18.7038 10.6351C18.7199 7.16711 17.8885 3.75044 16.2858 0.698242C16.37 0.788409 16.4439 0.888191 16.506 0.995662L25.2523 16.5755L30.2391 25.4274C30.3651 25.6447 30.4332 25.8923 30.4365 26.1453C30.4398 26.3983 30.3783 26.6477 30.258 26.8685C30.1378 27.0893 29.963 27.2737 29.7514 27.4031C29.5398 27.5325 29.2988 27.6024 29.0525 27.6057Z",
    fill: "url(#paint1_linear_1815_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0155 27.6056L10.214 27.5511L1.41878 27.526C1.17113 27.5271 0.927566 27.461 0.712732 27.3344C0.497899 27.2078 0.319395 27.0252 0.195276 26.805C0.0711573 26.5849 0.00581776 26.3349 0.00585939 26.0805C0.00590103 25.826 0.0713341 25.5761 0.195525 25.3559L1.22307 23.5545C3.81773 19.9883 7.44465 17.3574 11.5841 16.0391C13.2286 19.3917 15.7157 22.2315 18.7878 24.2645C21.8598 26.2974 25.4051 27.4495 29.0563 27.6014L29.0155 27.6056Z",
    fill: "url(#paint2_linear_1815_175)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.2223 15.0843H17.7371C16.8689 15.0821 16.0014 15.1353 15.1396 15.2434C15.4088 14.7826 15.6616 14.3092 15.894 13.8233C17.2051 11.0825 17.9136 8.07919 17.9695 5.02588C18.4633 6.8494 18.7103 8.73412 18.7034 10.6269C18.6986 12.1261 18.5373 13.6204 18.2223 15.0843Z",
    fill: "#523818"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M24.3797 26.8266C21.076 25.8817 18.056 24.0999 15.5967 21.6445C16.2014 20.6582 16.7238 19.6212 17.1584 18.5444C17.4315 19.1058 17.7251 19.6546 18.0473 20.1908C19.6484 22.8615 21.8123 25.1291 24.3797 26.8266Z",
    fill: "#523818"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M6.69907 19.9267C5.40243 20.3426 4.14974 20.8913 2.95996 21.5647C5.34305 19.0265 8.3084 17.1438 11.5839 16.0894C12.0829 17.096 12.6596 18.0598 13.3087 18.9716H12.852C10.7658 18.9678 8.69112 19.2899 6.69907 19.9267Z",
    fill: "#523818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2221 15.0841H17.7368C14.5316 15.0692 11.3677 15.8266 8.49902 17.2955C5.63035 18.7644 3.13687 20.9039 1.21875 23.5422L9.54098 8.91333L14.0589 0.953771C14.169 0.762098 14.3203 0.598883 14.5013 0.476601C14.6823 0.354318 14.8881 0.276223 15.1031 0.24832C15.318 0.220416 15.5363 0.243439 15.7412 0.315617C15.9461 0.387796 16.1322 0.507177 16.2852 0.664687C17.8879 3.71688 18.7193 7.13361 18.7032 10.6016C18.7001 12.1092 18.5388 13.612 18.2221 15.0841Z",
    fill: "url(#paint3_linear_1815_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0525 27.6057C24.008 27.3968 19.2163 25.2813 15.5967 21.6654C16.8327 19.65 17.7211 17.4307 18.2226 15.1051C18.5385 13.6371 18.6998 12.1385 18.7038 10.6351C18.7199 7.16711 17.8885 3.75044 16.2858 0.698242C16.37 0.788409 16.4439 0.888191 16.506 0.995662L25.2523 16.5755L30.2391 25.4274C30.3651 25.6447 30.4332 25.8923 30.4365 26.1453C30.4398 26.3983 30.3783 26.6477 30.258 26.8685C30.1378 27.0893 29.963 27.2737 29.7514 27.4031C29.5398 27.5325 29.2988 27.6024 29.0525 27.6057Z",
    fill: "url(#paint4_linear_1815_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0155 27.6056L10.214 27.5511L1.41878 27.526C1.17113 27.5271 0.927566 27.461 0.712732 27.3344C0.497899 27.2078 0.319395 27.0252 0.195276 26.805C0.0711573 26.5849 0.00581776 26.3349 0.00585939 26.0805C0.00590103 25.826 0.0713341 25.5761 0.195525 25.3559L1.22307 23.5545C3.81773 19.9883 7.44465 17.3574 11.5841 16.0391C13.2286 19.3917 15.7157 22.2315 18.7878 24.2645C21.8598 26.2974 25.4051 27.4495 29.0563 27.6014L29.0155 27.6056Z",
    fill: "url(#paint5_linear_1815_175)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M18.2223 15.0843H17.7371C16.8689 15.0821 16.0014 15.1353 15.1396 15.2434C15.4088 14.7826 15.6616 14.3092 15.894 13.8233C17.2051 11.0825 17.9136 8.07919 17.9695 5.02588C18.4633 6.8494 18.7103 8.73412 18.7034 10.6269C18.6986 12.1261 18.5373 13.6204 18.2223 15.0843Z",
    fill: "#523818"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M24.3797 26.8266C21.076 25.8817 18.056 24.0999 15.5967 21.6445C16.2014 20.6582 16.7238 19.6212 17.1584 18.5444C17.4315 19.1058 17.7251 19.6546 18.0473 20.1908C19.6484 22.8615 21.8123 25.1291 24.3797 26.8266Z",
    fill: "#523818"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M6.69907 19.9267C5.40243 20.3426 4.14974 20.8913 2.95996 21.5647C5.34305 19.0265 8.3084 17.1438 11.5839 16.0894C12.0829 17.096 12.6596 18.0598 13.3087 18.9716H12.852C10.7658 18.9678 8.69112 19.2899 6.69907 19.9267Z",
    fill: "#523818"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1815_175",
    x1: 1.23802,
    y1: 11.8772,
    x2: 18.6898,
    y2: 11.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F4C175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FBECD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28E54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1815_175",
    x1: 20.6099,
    y1: 3.2903,
    x2: 23.2027,
    y2: 24.4408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BA9962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9E1A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B38A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1815_175",
    x1: 23.3858,
    y1: 34.9731,
    x2: 0.839886,
    y2: 16.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A78743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F9E0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F0BD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BB9B57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1815_175",
    x1: 1.23802,
    y1: 11.8772,
    x2: 18.6898,
    y2: 11.9246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE7B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F4C175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FBECD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28E54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1815_175",
    x1: 20.6099,
    y1: 3.2903,
    x2: 23.2027,
    y2: 24.4408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#BA9962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9E1A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B38A4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1815_175",
    x1: 23.3858,
    y1: 34.9731,
    x2: 0.839886,
    y2: 16.1619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A78743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F9E0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F0BD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#BB9B57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1815_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCanvas);
export default __webpack_public_path__ + "static/media/logo-canvas.dfddc5b228b5a07b5e0ea709cb633b63.svg";
export { ForwardRef as ReactComponent };